"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCookies = exports.getCookie = exports.setLocalCookies = void 0;
const jwtDecoder_1 = require("../utils/jwtDecoder");
const js_cookie_1 = __importDefault(require("js-cookie"));
const a_second = 1000;
function setLocalCookies(tokens, domain) {
    const decodedAccessToken = jwtDecoder_1.getDecodedToken(tokens.accessToken);
    const decodedIdToken = jwtDecoder_1.getDecodedToken(tokens.idToken);
    const options = {
        domain,
        sameSite: 'none',
        secure: true,
        path: '/',
    };
    js_cookie_1.default.set('access_token', tokens.accessToken, Object.assign(Object.assign({}, options), { expires: new Date(decodedAccessToken.exp * a_second) }));
    js_cookie_1.default.set('id_token', tokens.idToken, Object.assign(Object.assign({}, options), { expires: new Date(decodedIdToken.exp * a_second) }));
}
exports.setLocalCookies = setLocalCookies;
function getCookie(cookieName) {
    return js_cookie_1.default.get(cookieName);
}
exports.getCookie = getCookie;
function removeCookies(domain) {
    js_cookie_1.default.remove('access_token', {
        domain,
    });
    js_cookie_1.default.remove('id_token', {
        domain,
    });
}
exports.removeCookies = removeCookies;
